module.exports = __webpack_public_path__ + "static/media/return-on-investment.44e4d2a8.svg";